import { VisualChartType } from '../../../shared/chart/chart';
import { FilterDto, ListUserDashboardDto, ListUserVisualDto, VisualFieldDto } from '../../../services/api.services';
import { IItemSelectorCategory, IItemSelectorItem } from '../item-selector/reducer';

export enum InsightsLibraryPage {
  Insights = 'insights',
  Dashboards = 'dashboards',
};

export interface InsightsLibraryItem extends IItemSelectorItem {
  categories: string[];
};

export interface InsightsLibraryDashboard extends InsightsLibraryItem {
  dashboard: ListUserDashboardDto;

  canView: boolean;
  canCopy: boolean;
  canAddToHome: boolean;

  fields: string[];
  initialFilters: FilterDto[];
  filters: FilterDto[];
};

export interface InsightsLibraryVisual extends InsightsLibraryItem {
  visual: ListUserVisualDto;

  canView: boolean;
  canCopy: boolean;

  chartType: VisualChartType;

  fields: VisualFieldDto[];
  initialFilters: FilterDto[];
  filters: FilterDto[];
};

export interface InsightsLibraryDashboardCategory extends IItemSelectorCategory<InsightsLibraryDashboard> {
};

export interface InsightsLibraryVisualCategory extends IItemSelectorCategory<InsightsLibraryVisual> {
};

